import { render } from "./Switch.vue?vue&type=template&id=48ee860a&scoped=true&ts=true"
import script from "./Switch.vue?vue&type=script&lang=ts"
export * from "./Switch.vue?vue&type=script&lang=ts"

import "./Switch.vue?vue&type=style&index=0&id=48ee860a&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ee860a"]])

export default __exports__